import React from 'react';
import PropTypes from 'prop-types';
import { TextBoxPopup, SignaturePopup, SelfServeBuilderPopupTypes } from 'Popups';

class PopupManager extends React.PureComponent {
  renderPopup() {
    const { TEXTBOX, SIGNATURE } = SelfServeBuilderPopupTypes;
    const popupData = this.props.popupData;
    const isSelected = this.props.id === this.props.highlightedFieldId;
    if (popupData) {
      switch (popupData.type) {
        case TEXTBOX:
          return (
            <TextBoxPopup
              addPaddingTop={this.props.addPaddingTop}
              bounds={this.props.bounds}
              data={popupData}
              draggable={this.props.draggable}
              getSuperScriptValue={this.props.getSuperScriptValue}
              id={this.props.id}
              key={this.props.id}
              resizable={this.props.resizable}
              isPreviewMode={this.props.isPreviewMode}
              zoomFactor={this.props.zoomFactor}
            />
          );
        case SIGNATURE:
          return (
            <SignaturePopup
              addPaddingTop={this.props.addPaddingTop}
              bounds={this.props.bounds}
              data={popupData}
              draggable={this.props.draggable}
              getSuperScriptValue={this.props.getSuperScriptValue}
              id={this.props.id}
              isSelected={isSelected}
              key={this.props.id}
              resizable={this.props.resizable}
              isPreviewMode={this.props.isPreviewMode}
              zoomFactor={this.props.zoomFactor}
            />
          );
        default:
          return null;
      }
    } else {
      return null;
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.renderPopup()}
      </React.Fragment>
    );
  }
}

PopupManager.propTypes = {
  addPaddingTop: PropTypes.func.isRequired,
  bounds: PropTypes.string.isRequired,
  draggable: PropTypes.bool.isRequired,
  getSuperScriptValue: PropTypes.func.isRequired,
  highlightedFieldId: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  popupData: PropTypes.shape({
    label: PropTypes.string,
    type: PropTypes.string,
    id: PropTypes.string,
    pageIdx: PropTypes.number,
  }).isRequired,
  resizable: PropTypes.bool.isRequired,
  isPreviewMode: PropTypes.bool.isRequired,
  zoomFactor: PropTypes.number.isRequired,
};

export default PopupManager;



// WEBPACK FOOTER //
// ./src-react/Popups/SelfServeBuilderPopups/PopupManager.jsx